import { render, staticRenderFns } from "./addUser.vue?vue&type=template&id=2989e37e&scoped=true&"
import script from "./addUser.vue?vue&type=script&lang=js&"
export * from "./addUser.vue?vue&type=script&lang=js&"
import style0 from "./addUser.vue?vue&type=style&index=0&id=2989e37e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989e37e",
  null
  
)

export default component.exports